import { render, staticRenderFns } from "./DeleteableDocumentListItem.vue?vue&type=template&id=852f6a4c"
import script from "./DeleteableDocumentListItem.vue?vue&type=script&lang=js"
export * from "./DeleteableDocumentListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports